import { Component, OnInit ,Input } from '@angular/core';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { SwQuickMenusBoxComponent } from './sw-quick-menus-box/sw-quick-menus-box.component';
import { Router } from '@angular/router';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'sw-quick-menus',
  templateUrl: './sw-quick-menus.component.html',
  styleUrls: ['./sw-quick-menus.component.css']
})
export class SwQuickMenusComponent implements OnInit {
  @Input() opentype = 0; //0默认在当前程序打开，1在新标签页打开
  @Input() width = '23%'
  @Input() hasHeader:boolean = true  //是否有头部，默认有
  @Input() hasBorder:boolean = true  // div.box元素是否有边框
  MenusList:any=[];  //显示的快捷菜单
  initMenusList:any=[];  //请求返回的快捷菜单
  constructor(
    private create:SwCreateModalComponentService,
    private box:SwMassageBoxService,
    private router:Router,
    private http:SwHttpClientService, 
    private jwt: SwJwtService,
    private Location: PlatformLocation,
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.quickMenus()
  }
  clickMenus(){
    //处理要回显的菜单
    this.create.createModal(SwQuickMenusBoxComponent,{selectedMenus:this.initMenusList},this.quickMenus.bind(this))
  }

  quickMenus(){
    this.http.Post(environment.seekerWebAPI + "shortcut/queryShortcut",{}).subscribe(data => {
      if (data["code"] == 200) {
        let uriList = data["data"].filter(item=>item.uri)  //过滤掉没有uri的
        // let uriList = data["data"]
        this.MenusList = uriList 
        this.initMenusList = JSON.parse(JSON.stringify(uriList))
        this.MenusList.push({functionName:'更多',icon:'icon iconfont iconbtn_card',uri:'more'})
        
      } else {
        this.box.danger("获取快捷菜单数据")
      }
    })
  }

  
  RouterLinek(item){
    if(item.uri == 'more'){
      //如果是点击更多,就打开模态框
      this.clickMenus()
    } else {
      if(this.opentype==1){
        let url="#"+item.uri+"?Title="+item.functionName;
        window.open(url);
      }else{
        if(environment["enableModuleDeploy"]){  //不同站点
          // let uri = 'http://localhost:4510/#/login?functionCode=drm&RedirectUrl=/drm/CommonResourceQuery';
          //在跳转地址中找到对应的模块 
          let arr = item.uri.split('/')
          let functionCode = arr[1]
          if(functionCode.toLocaleLowerCase() == 'oa' || functionCode.toLocaleLowerCase() == 'bdp'){
            //默认方式打开,根据路由跳转链接
            this.router.navigate([item.uri], {
              queryParams: {Title:item.functionName} ,
            });
          } else {
            let sites:any = environment["moduleSites"]
            if(sites){
              sites = JSON.parse(sites)
              //如果要跳转的模块所属的站点就是当前地址栏的站点，就不用新开标签页
              let path = this.Location["location"].href
              let currentSite = path.split('#')[0].toLocaleLowerCase()
              let currentSiteFunctionCode
              //找到当前地址栏是属于哪个模块的站点地址
              for (const key in sites) {
                if(sites[key].indexOf(currentSite) > -1){
                  currentSiteFunctionCode = key
                }
              }
              if(currentSiteFunctionCode == functionCode.toLocaleLowerCase()){
                //默认方式打开,根据路由跳转链接
                this.router.navigate([item.uri], {
                  queryParams: {Title:item.functionName} ,
                });
              } else {
                let site = sites[functionCode.toLocaleLowerCase()]
                if(site){
                  //看配置的站点信息中有没有参数
                  let siteInfo = site.split('?')
                  if(siteInfo.length >=2){  //如果有站点信息
                    site = siteInfo[0]    //单纯的站点,不带参数的
                  }
                  //获取到该模块的站点了，就可以拼接新地址，进行跳转操作
                  let token = this.jwt.getlocaToken('token')
                  let systemId = this.jwt.getlocaToken('systemId')
                  let queryParams = JSON.stringify({ Title: item.functionName })
                  let newUri = site + '#/login?functionCode='+functionCode+'&RedirectUrl='+item.uri+'&token='+token+'&systemId='+systemId+'&queryParams='+queryParams
                  window.open(newUri)  //用不同的站点打开不同的模块
                } else {
                  this.box.danger('缺少该模块站点配置项')
                }

              }
            } else {
              this.box.danger('缺少站点配置项')
            }

          }
 
        } else {
          //默认方式打开,根据路由跳转链接
          this.router.navigate([item.uri], {
            queryParams: {Title:item.functionName} ,
          });
        }
        
      } 
    }
  }
}
